// extracted by mini-css-extract-plugin
export var carrierIcon = "_uq-0";
export var carrierLogo = "_uq-1";
export var detailsSection = "_uq-2";